// 401 messages that get one token refresh and a retry, in both axios clients (no imports, so Node's test runner loads it).
// A support token whose grant is gone: the refresh is refused too, which ends the session.
export const notAuthorizedCodes = ['Unauthorized', 'InvalidUserToken', 'SessionExpired', 'UserSessionNotFound', 'Token invalid', 'Support access is no longer allowed',];
